import React from 'react';
import { TagFilled, CloseOutlined } from '@ant-design/icons';
import { WorkOrderLabel } from '../../data/workOrderStarLabels';

interface Props {
	label: WorkOrderLabel | null | undefined;
	onClick?: (event: React.MouseEvent) => void;
	onRemove?: (event: React.MouseEvent) => void;
	className?: string;
}

const WorkOrderLabelChip: React.FC<Props> = ({ label, onClick, onRemove, className }) => {
	if (!label) return null;
	return (
		<span
			onClick={onClick}
			className={`bodyregular box-border inline-flex h-[30px] items-center gap-1 rounded-full border border-solid !border-grey-5 bg-white px-2 py-[3px] text-character-primary ${
				onClick ? 'cursor-pointer' : 'cursor-default'
			}${className ? ` ${className}` : ''}`}
		>
			<TagFilled className="text-xs" style={{ color: label.color }} />
			<span className="max-w-[140px] overflow-hidden text-ellipsis whitespace-nowrap text-black/65">
				{label.label}
			</span>
			{onRemove ? (
				<CloseOutlined
					onClick={(event) => {
						event.stopPropagation();
						onRemove(event);
					}}
					className="ml-0.5 cursor-pointer text-[10px] text-grey-7"
				/>
			) : null}
		</span>
	);
};

export default WorkOrderLabelChip;
